import React, { useEffect } from "react";
import PropTypes from "prop-types";
import PublicComponent from "../PublicComponent";
import { useMutationWithErrorHandling } from "hooks/errorHandling";
import { partnerConsents } from "constants/partnerConsents";
import { ADD_CONTACT_CONSENT } from "features/client/mutations";
import { get, set } from "@totalsoft/react-state-lens";
import { useLocation } from "react-router-dom";

const PublicGdprConsent = (props) => {
  const { stateLens, tokenExpired } = props;
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const quoteId = stateLens.data.quoteId |> get;

  const [addContactConsent, { loading }] = useMutationWithErrorHandling(ADD_CONTACT_CONSENT);

  useEffect(() => {
    if (tokenExpired) return;
    const input = {
      quoteId,
      partnerId: parseInt(queryParams.get("partnerId")),
      consentCode: partnerConsents.customerConsent,
      contactPersons: {
        webQuoteContactInfoId: parseInt(queryParams.get("webQuoteContactInfoId")),
        genderId: parseInt(queryParams.get("genderId")),
        firstName: queryParams.get("firstName"),
        lastName: queryParams.get("lastName"),
        email: queryParams.get("email"),
        citizenshipId: parseInt(queryParams.get("citizenshipId")),
      },
    };
    addContactConsent({ variables: { input } });
  }, [tokenExpired, addContactConsent]);

  useEffect(() => {
    (stateLens.loading |> set)(loading);
  }, [loading, stateLens.loading]);

  return <></>;
};

PublicGdprConsent.propTypes = {
  stateLens: PropTypes.object.isRequired,
  tokenExpired: PropTypes.bool.isRequired,
};

export default () => <PublicComponent Component={PublicGdprConsent} />;
